import styled from 'styled-components';

export const StyledPermissonContent = styled('div')`
  .ant-form-item {
    text-align: center;
    margin: auto;
  }
`;
